import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { DirectoryDomain } from 'src/app/models/directory/enums/DirectoryDomain.enum';
import { GraphApplicationsUpdateRequest } from 'src/app/models/graph/applications/GraphApplicationsUpdateRequest';
import { GraphApplicationUpdate } from 'src/app/models/graph/applications/GraphApplicationUpdate';
import { GraphApplicationService } from 'src/app/services/graph/GraphApplication.service';
import { environment } from "src/environments/environment";


@Component({
  selector: 'request-details-application-update',
  templateUrl: './request-details-application-update.component.html'
})

export class RequestDetailsApplicationUpdate implements OnChanges {
  @Input() requestData: GraphApplicationsUpdateRequest | GraphApplicationUpdate[];
  @Output() doneLoading = new EventEmitter<boolean>();

  isClientSecretConfigCapabilitiesEnabled: boolean = environment.isClientSecretConfigCapabilitiesEnabled;

  displayColumns: string[] = ['displayName', 'newServiceId', 'removedPrivilegedAppRole'];
  displayObjects: any[] = [];
  constructor(
    private graphApplicationService: GraphApplicationService,
  ) {

    if (this.isClientSecretConfigCapabilitiesEnabled) {
      // once the capability is available from APU we can add the following columns
      this.displayColumns.push('addedKeyvaultConfig')
      this.displayColumns.push('removedKeyvaultConfig')
    }
  }


  async ngOnChanges(): Promise<void> {
    let applicationUpdates = typeof this.requestData === 'object' && 'applicationUpdates' in this.requestData ?
      this.requestData.applicationUpdates : this.requestData;

    const needsFullDetails = applicationUpdates.some(x =>
      x.adminAppRolesToRemove && x.adminAppRolesToRemove.length > 0
    );
    const domain = typeof this.requestData === 'object' && 'domain' in this.requestData ?
      this.requestData.domain : DirectoryDomain.Chevron;

    var updatedApplications = await this.loadUpdatedApplications(
      domain,
      applicationUpdates.map(x => x.applicationId) as string[],
      needsFullDetails
    );
    this.displayObjects = applicationUpdates.map((application: GraphApplicationUpdate) => {
      const updatedApplication = updatedApplications.find(x => x.id === application.applicationId);
      if (updatedApplication) {
        application.displayName = updatedApplication.displayName;
        application.id = updatedApplication.id;
      }
      else {
        application.displayName = application.id;
      }

      return {
        id: application.applicationId,
        displayName: application.displayName,
        newServiceId: application.newServiceId,
        addedKeyvaultConfig: application.clientSecretAutoRotationConfigsToAdd?.map(c => c.id).join(", "),
        removedKeyvaultConfig: application.clientSecretAutoRotationConfigsToRemove?.map(c => c.id).join(", "),
        removedPrivilegedAppRole: application.adminAppRolesToRemove?.map(c => {
          const exposedPermission = updatedApplication?.exposedPermissions?.find(p => p.id === c && p.type.endsWith(".appRole"));
          return exposedPermission ? exposedPermission.value : c;
        }).join(", "),
        copyId: application.applicationId,
      }
    });
    this.doneLoading.emit(true);
  }

  async loadUpdatedApplications(domain: DirectoryDomain, ids: string[], fullDetails: boolean = false) {
    return await this.graphApplicationService.GetApplicationsByIdsAsync(domain, ids, fullDetails);
  }
  isDoneLoading() {
    this.doneLoading.emit(true);
  }
}
